/**
 * Lib.Common: Main entry point
 *
 * This registers all lib.common components and adds global methods and properties
 * to the Vue prototype.
 */


import './less/tag.less';

import $app         from './prototype/app';
import $date        from './prototype/date';
import $device      from './prototype/device';
import $locale      from './prototype/locale';
import $markdown    from './prototype/markdown';
import $media       from './prototype/media';
import $num         from './prototype/num';
import $overlay     from './prototype/overlay';
import $rtl         from './prototype/rtl';
import $string      from './prototype/string';
import $telemetry   from './prototype/telemetry';
import $util        from './prototype/util';

import _layout      from './components/layout';
import _view        from './components/view';
import _button      from './components/button';
import _form        from './components/form';
import _graph       from './components/graph';
import _misc        from './components/misc';
import _nav         from './components/nav';
import _progress    from './components/progress';
import _table       from './components/table';
import _trans       from './components/transition';

import $alert       from './prototype/alert';
import $confirm     from './prototype/confirm';
import $tooltip     from './prototype/tooltip';

import vdate        from './directive/date';
import vlabel       from './directive/label';
import vlabelback   from './directive/label-back';
import vlabelnext   from './directive/label-next';
import vlabeldone   from './directive/label-done';
import vmarkdown    from './directive/markdown';
import vnum         from './directive/num';

import './less/index.less';


const haveVue = typeof Vue !== 'undefined';


(function(vue, global) {
    vue.$app        = global.$app         = $app;
    vue.$date       = global.$date        = $date;
    vue.$device     = global.$device      = $device;
    vue.$locale     = global.$locale      = $locale;
    vue.$markdown   = global.$markdown    = $markdown;
    vue.$num        = global.$num         = $num;
    vue.$string     = global.$string      = $string;
    vue.$telemetry  = global.$telemetry   = $telemetry;
    vue.$util       = global.$util        = $util;

    vue.$alert      = $alert;
    vue.$confirm    = $confirm;
    vue.$overlay    = $overlay;
    vue.$tooltip    = $tooltip;
}(haveVue ? Vue.prototype : {}, window));


if (haveVue) {
    [
        _layout,
        _view,
        _button,
        _form,
        _graph,
        _misc,
        _nav,
        _progress,
        _table,
        _trans
    ].forEach(
        grp => grp.forEach(
            cmp => Vue.component(cmp.name, cmp))
    );

    [
        vdate,
        vlabel,
        vlabelback,
        vlabelnext,
        vlabeldone,
        vmarkdown,
        vnum
    ].forEach(
        dir => Vue.directive(dir.name, dir.directive)
    );

    Vue.util.defineReactive(Vue.prototype, '$media', $media);
    Object.defineProperty(Vue.prototype, '$rtl', $rtl);
}


if ($build.env != 'production') {
    console.log('lib.common development build: ' + $build.platform + '/' + $version);
}
